import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { purpurColorRed600 } from '@purpurds/tokens/color/variables';
import styled from 'styled-components';
import spacing from 'theme/spacing';
const StyledProductItemInactive = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const StyledProductItemLeft = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  justify-content: center;
  text-align: left;
`;
const StyledIcon = styled(Icon) `
  margin-right: ${spacing.spacing8};
  color: ${purpurColorRed600};
  cursor: pointer;
`;
const ProductItemStatus = styled.span `
  font-size: 16px;
  font-weight: 300;
  color: ${purpurColorRed600};
`;
const ProductRight = styled.div `
  position: absolute;
  right: 0;
`;
export const ProductItemContentInactive = ({ onActivate, name, showDeleteButton = false, removeProduct, leftText, }) => (_jsxs(StyledProductItemInactive, { children: [_jsxs(StyledProductItemLeft, { onClick: onActivate, children: [_jsx("span", { children: name }), _jsx(ProductItemStatus, { children: leftText })] }), _jsx(ProductRight, { children: showDeleteButton && (_jsx(StyledIcon, { svg: icons.remove, onClick: removeProduct })) })] }));
